import React from 'react';
import cx from 'classnames';

import PrimaryLink from '../PrimaryLink';

import styles from './NavigationDrillIn.module.scss';

export interface NavigationDrillInProps {
  /** Should contain `Navigation.Item` and `Navigation.Group`.*/
  children?: React.ReactNode;
  /** Apply CSS class to the container. */
  className?: Parameters<typeof cx>[0];
  /** Function that will be called when the back button is clicked. */
  onBack?: () => void;
}

export const NavigationDrillIn: React.FC<NavigationDrillInProps> = ({
  children,
  className,
  onBack,
}) => {
  return (
    <div className={cx(styles.drillIn, className)}>
      <PrimaryLink left size={14} onClick={onBack} className={styles.backBtn}>
        Back<span className='visually-hidden'>to main navigation</span>
      </PrimaryLink>
      {children}
    </div>
  );
};

export default NavigationDrillIn;
export { styles };
